import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminPlatformFeature } from '@/api/(admin)/platform-features';
import { adminPlatformFeaturesQueryKey } from './useAdminPlatformFeatures';

/** One feature — the detail screen's header. */
export function adminPlatformFeatureQueryOptions(featureId: string) {
  return queryOptions({
    queryKey: [...adminPlatformFeaturesQueryKey, 'detail', featureId] as const,
    queryFn: () => fetchAdminPlatformFeature(featureId),
    enabled: Boolean(featureId),
  });
}

export function useAdminPlatformFeature(featureId: string) {
  const query = useQuery(adminPlatformFeatureQueryOptions(featureId));
  return { ...query, feature: query.data?.data ?? null };
}
